<template>
  <el-dialog :title="title" :visible="visible" width="500px" :close-on-click-modal="false" :before-close="handleClose"  @open="getEditForm()">
    <el-alert
      v-show="editForm.type === 2"
			title="网段配置的格式为：10.x.x.x。且最后一位必须为x"
			type="warning"
			show-icon
			:closable="false"
      style="margin-bottom: 20px;"
		></el-alert>
    <el-form :model="editForm" :rules="rules" ref="editForm" style="width: 400px" label-width="100px">
      <el-form-item prop="ip" label="IP地址">
        <el-input v-model="editForm.ip" placeholder="请输入IP地址" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item prop="type" label="配置类型">
        <el-radio-group v-model="editForm.type">
          <el-radio :label="1">IP</el-radio>
          <el-radio :label="2">网段</el-radio>
        </el-radio-group>
			</el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ip: String
  },
  data () {
    return {
      title: '新增白名单',
      editForm: {
        ip: '',
        type: 1
      },
      typeShow: false,
      rules: {
        ip: [{ required: true, message: '请输入IP地址', trigger: 'blur' }],
        type: [{ required: true, message: '请选择配置类型', trigger: 'blur' }],
      }
    }
  },
  methods: {
    getEditForm () {
      this.$refs.editForm?.resetFields();
    },
    handleClose () {
      this.$emit('close')
    },
    handleSave () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$api.system.saveWhiteListInfo(this.id, this.editForm).then(res => {
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.$emit('close', true)
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

</style>
